<template>
    <div>
        <!-- <TheNavigationPanel/> -->
        <v-container>
            <v-toolbar flat color="#F0FFEA" height="50" >
                <v-toolbar-title style="color:#62AE32" class="headline">View Transaction</v-toolbar-title>
            </v-toolbar>  

            <div class="mt-6 mb-5" >
                <v-card class="ml-12" color="#F0FFEA" max-width="600" flat > 
                    <v-row no-gutters class="mb-n4">
                        <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Transaction Id:</span>
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                label=""
                                readonly
                                solo
                                flat
                                dense
                                v-model="transactId"
                                style="font-size:14px"
                                class="black--text"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mb-n4">
                        <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Transaction Ref No:</span>
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                label=""
                                readonly
                                solo
                                flat
                                dense
                                v-model="refNo"
                                style="font-size:14px"
                                class="black--text"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mb-n4">
                        <v-col cols="12" md="4" sm="6" class="mt-2">
                            <span style="font-size:13px; color:#615D5D">Depositor's Name</span>
                            
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                readonly
                                label=""
                                solo
                                flat
                                dense
                                v-model="depositorName"
                                style="font-size:14px"
                                class="black--text"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mb-n4">
                        <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Amount Payable:</span>
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                label=""
                                readonly
                                solo
                                flat
                                dense
                                v-model="amountPaid"
                                style="font-size:14px"
                                class="black--text"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                     <v-row no-gutters class="mb-n4">
                        <v-col cols="12" md="4" sm="6" class="mt-2">
                            <span style="font-size:13px; color:#615D5D">Payment Status</span>                  
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                readonly
                                label=""
                                solo
                                flat
                                dense
                                v-model="payStatus"
                                style="font-size:14px"
                                class="black--text"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mb-n4">
                        <v-col cols="12" md="4" sm="6">
                            <span style="font-size:13px; color:#615D5D">Transaction Type</span>
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                readonly
                                label=""
                                solo
                                flat
                                dense
                                v-model="transType"
                                style="font-size:14px"
                                class="black-text"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mb-n4">
                        <v-col cols="12" md="4" sm="6" class="mt-2">
                            <span style="font-size:13px; color:#615D5D">Payment Method</span>
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                readonly
                                label=""
                                solo
                                flat
                                dense
                                v-model="paymentMethod"
                                style="font-size:14px"
                                class="black--text"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mb-n4">
                        <v-col class="mt-2" cols="12" md="4" sm="6">
                            <span style="font-size:13px; color:#615D5D">Transaction Date</span>
                            
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                readonly
                                label=""
                                solo
                                flat
                                dense
                                v-model="datePaid"
                                style="font-size:14px"
                                class="black--text"
                            ></v-text-field>
                        </v-col>
                    </v-row >
                    <v-row no-gutters class="mb-n4">
                        <v-col cols="12" md="4" sm="6" class="mt-2">
                            <span style="font-size:13px; color:#615D5D">Bank Name</span>                  
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                readonly
                                label=""
                                solo
                                flat
                                dense
                                v-model="bank"
                                style="font-size:14px"
                                class="black--text"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                     <v-row no-gutters class="mb-n4">
                        <v-col cols="12" md="4" sm="6" class="mt-2">
                            <span style="font-size:13px; color:#615D5D">Account Name</span>                  
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                readonly
                                label=""
                                solo
                                flat
                                dense
                                v-model="acctName"
                                style="font-size:14px"
                                class="black--text"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                     <v-row no-gutters class="mb-n4">
                        <v-col cols="12" md="4" sm="6" class="mt-2">
                            <span style="font-size:13px; color:#615D5D">Account Number</span>                  
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                readonly
                                label=""
                                solo
                                flat
                                dense
                                v-model="acctNum"
                                style="font-size:14px"
                                class="black--text"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mb-n4">
                        <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Community Name:</span>
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                label=""
                                readonly
                                solo
                                flat
                                dense
                                v-model="community"
                                style="font-size:14px"
                                class="black--text"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mb-n4">
                        <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Community Code</span>
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                label=""
                                readonly
                                solo
                                flat
                                dense
                                v-model="communityId"
                                style="font-size:14px"
                                class="black--text"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mb-n4">
                        <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Policy Holder</span>
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                label=""
                                readonly
                                solo
                                flat
                                dense
                                v-model="policyHolder"
                                style="font-size:14px"
                                class="black--text"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <!-- <v-row no-gutters class="mb-n4">
                        <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Policy Holder Username</span>
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                label=""
                                readonly
                                solo
                                flat
                                dense
                                v-model="policyHolderUsername"
                                style="font-size:14px"
                                class="black--text"
                            ></v-text-field>
                        </v-col>
                    </v-row> -->
                    <v-row no-gutters class="mb-n4">
                        <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Policy Number:</span>
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                label=""
                                readonly
                                solo
                                flat
                                dense
                                v-model="policyNumber"
                                style="font-size:14px"
                                class="black--text"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <!-- <v-row no-gutters class="mb-n4">
                        <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Vehicle Make:</span>
                        </v-col>
                        <v-col cols="12" md="8" sm="6">
                            <v-text-field
                                label=""
                                readonly
                                solo
                                flat
                                dense
                                v-model="vehicleMake"
                                style="font-size:14px"
                                class="black--text"
                            ></v-text-field>
                        </v-col>
                    </v-row> -->
                </v-card>
            </div>
        </v-container>
    </div>
</template>

<script>
// import TheNavigationPanel from '../components/TheNavigationPanel';
export default {
    name: 'viewTransaction',
    components: {
        // TheNavigationPanel,
    },

    data(){
        return{
            transactId:"",
            acctName:"",
            acctNum:"",
            refNo: '',
            depositorName: '',
            amountPaid: '',
            transType: '',
            paymentMethod: '',
            datePaid: '',
            bank: '',
            community: '',
            communityId: '',
            policyNumber: '',
            policyHolder: '',
            vehicleMake: '',
            policyHolderUsername:'',
            payStatus:""
            
        }
    },
    computed:{
        ViewTransactions(){
            return this.$store.state.transactions.transactionsbyid
        }
    },
    created(){
        this.transactId = this.$store.state.transactions.transactionsbyid.transaction_id
        this.payStatus = this.$store.state.transactions.transactionsbyid.payment_status
        this.acctName = this.$store.state.transactions.transactionsbyid.account_name
        this.acctNum = this.$store.state.transactions.transactionsbyid.account_number
        this.refNo =  this.$store.state.transactions.transactionsbyid.transaction_ref_number
        this.depositorName = this.$store.state.transactions.transactionsbyid.depositors_name
        // this.amountPaid = this.$store.state.transactions.transactionsbyid.payment_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.amountPaid = parseFloat(this.$store.state.transactions.transactionsbyid.payment_amount).toFixed(2);
        this.amountPaid = this.amountPaid.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        this.transType = this.$store.state.transactions.transactionsbyid.transaction_type
        this.paymentMethod = this.$store.state.transactions.transactionsbyid.payment_method
        this.datePaid = this.$store.state.transactions.transactionsbyid.date_created.slice(0, 19).replace('T', ' ')
        this.bank = this.$store.state.transactions.transactionsbyid.bank
        this.communityId = this.$store.state.transactions.transactionsbyid.community_id
        this.community = this.$store.state.transactions.transactionsbyid.community_name
        this.policyNumber = this.$store.state.transactions.transactionsbyid.policy_number
        this.policyHolder = this.$store.state.transactions.transactionsbyid.policy_holder
        this.vehicleMake = this.$store.state.transactions.transactionsbyid.vehicle_make
        this.bank = this.$store.state.transactions.transactionsbyid.bank_name
        this.communityId = this.$store.state.transactions.transactionsbyid.community_code
        this.policyHolderUsername = this.$store.state.transactions.transactionsbyid.policy_holder.toUpperCase()
    }
}
</script>

<style scoped>

</style>